import { cn } from '@shared/utils';
import type { IntegrationResponse } from '@shared/api';
import { IntegrationCard } from './integrationCard';

interface IntegrationListProps {
  className?: string;
  list: IntegrationResponse[];
}

export const IntegrationList = (props: IntegrationListProps) => {
  return (
    <div className={cn('flex flex-wrap', props.className)}>
      <div className='w-full max-w-[330px] flex-none'>
        {props.list.map((integration) => (
          <IntegrationCard key={integration.name} integration={integration} />
        ))}
      </div>
    </div>
  );
};
